import Checkout from '../classes/Checkout';

export default function(){
    jQuery('.cart-page').each(function(){
        new Checkout(jQuery(this));
    });
}